import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

/**
 * Get all image quality records
 * @param {number} limit - Number of records per page
 * @param {number} offset - Offset for pagination
 * @returns {Promise<Object>} Records data with pagination
 */
export async function getRecords(limit = 50, offset = 0) {
  const response = await axios.get(
    `${API_BASE_URL}/api/image-quality/records`,
    {
      params: { limit, offset }
    }
  );
  return response.data;
}

/**
 * Get specific record detail
 * @param {string} itemCode - Item code
 * @param {string} imageType - Image type
 * @returns {Promise<Object>} Record detail
 */
export async function getRecordDetail(itemCode, imageType) {
  const response = await axios.get(
    `${API_BASE_URL}/api/image-quality/records/${itemCode}/${imageType}`
  );
  return response.data;
}

/**
 * Get signed URL for an image
 * @param {string} itemCode - Item code
 * @param {string} imageType - Image type
 * @returns {Promise<string>} Signed image URL
 */
export async function getImageUrl(itemCode, imageType) {
  const response = await axios.get(
    `${API_BASE_URL}/api/image-quality/image-url/${itemCode}/${imageType}`
  );
  return response.data.url;
}
